import React from "react";
import { ActionProps } from "react-querybuilder";

export const CustomLockRuleAction: React.FC<ActionProps> = (props) => {
    return null;
};
